<ng-http-loader
  spinner="sk-cube-grid"
  [backgroundColor]="'#fe7c18'"
></ng-http-loader>
<router-outlet></router-outlet>
